
import React, {Component} from 'react';
import {Modal,ButtonToolbar,Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import PODocStore from '../../stores/PODocStore'
import ConfirmPopup from 'component/element/ConfirmPopup'

class PurchaseFromWorkRecordModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {showDelete:false,item:{}}
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onDelClick(){
    let {item} = this.state
    PODocStore.delPODoc(item.purchase_order_no,()=>{
      this.setState({showDelete:false})  
      this.props.onHide()
    })
  }

  onRowDelete(item){
    this.setState({showDelete:true,item:item})
  }

  onRowClick(item){
    if(this.props.onSelectItem!==undefined){
      this.props.onSelectItem(item)
    }
  }

  renderRowData(){
    if(this.props.list.length===0){
      return (<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    }
    return this.props.list.map((item,index)=>
    (<tr key={index}>
      <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.added_date}</td>
      <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.purchase_order_no}</td>
      <td className='text-right' onClick={this.onRowClick.bind(this,item)}>{this.getNumberFormat(item.amount)}</td>
      <td className='text-center'><Button bsStyle='danger' onClick={this.onRowDelete.bind(this,item)}><FontAwesome name='trash'/></Button></td>
    </tr>))
  }

  renderTable(){
    let {messages} = this.props
    let {doc} = this.state
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>วันที่/เวลา</th>                        
            <th className='text-center' style={{width:'70px'}}>เอกสารเลขที่</th>            
            <th className='text-center' style={{width:'120px'}}>มูลค่า</th>
            <th className='text-center' style={{width:'30px'}}>ลบทิ้ง</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>        
      </table>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    return (
      <div >
        <ButtonToolbar className='pull-right'>
          <Button bsStyle='primary' onClick={this.props.onNewDoc}><FontAwesome name='file-o'/>&nbsp;{'สร้างใหม่'}</Button>
          <Button onClick={this.props.onHide}><FontAwesome name='close'/>&nbsp;{'ยกเลิก'}</Button>
        </ButtonToolbar>        
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {showDelete} = this.state
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Body>
            {this.renderTable()}
        </Modal.Body>  
        <Modal.Footer>
          {this.renderNewItemButton()}
        </Modal.Footer>   
        <ConfirmPopup
          show={showDelete}
          onHide={()=>{this.setState({showDelete:false})}}
          title={'ยืนยัน'}
          message={'ยืนยันการลบรายการ?'}
          onConfirm={this.onDelClick.bind(this)}
        />   
      </Modal> 
    )
  }
}

PurchaseFromWorkRecordModal.defaultProps = {
  show :false,
  list:[]
}


export default PurchaseFromWorkRecordModal;





// WEBPACK FOOTER //
// ./src/view/po/PurchaseFromWorkRecordModal.js